<template>
    <div id = "about">
        <AboutHero />
        <History />
        <div id="title-org-container"> 
            <div id="title-org"> 
                ECHIPA DE ORGANIZARE 
            </div> 
        </div>
        <div class="alt-div">
            <div id="organising-team" class = "columns is-multiline is-centered">
                <div id="items-org" v-for="(obj,index) in organisers" :key="index">
                    <ContactPersonCard  :contactPerson="obj"></ContactPersonCard>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import organisers from '@/assets/resources/organisers.js'

import ContactPersonCard from '@/components/contact-components/ContactPersonCard'
import History from "@/components/about-components/History"
import AboutHero from "@/components/about-components/AboutHero"

export default {
    components: {
        ContactPersonCard,
        History,
        AboutHero
    },
    data() {
        return {
            organisers,
        }
    }
}
</script>

<style scoped lang="scss">

#cards-container{
    display: flex;
    height: 100%;
    width: 100%;
    flex-wrap: wrap;
    background-color:#0D2A4C;
    justify-content: center;
}

#about {
    background-color:  #0D2A4C;
}
#title-org{
    color: white;
    font-size: calc(20px + (70 - 20) * ((100vw - 600px) / (3840 - 600)));
    border-bottom: 1px solid white;
    text-align: center;
    display: inline-block;
    font-family: Acumin Variable Concept;
	font-weight: bold;
    margin-bottom: 2vh;
}

#title-org-container {
    display:flex;
    justify-content: center;
}
.alt-div {
    margin-left: 15vw;
    margin-right: 15vw;
    align-content: center;
    padding-bottom: 90px;
    padding-top: 40px;

}
#organising-team {
  display: flex;
  flex-wrap: wrap;
//   align-items: stretch;
  justify-content: space-around!important;
}

#items-org {
  flex: 1 0 calc(33.33% - 20px);
  max-width: calc(33.33% - 20px);
  flex-grow: 1;
  padding: 1vw;
}

@media (max-width: 600px) { 
   .alt-div {
        margin-left: 0;
        margin-right: 0;
        width: 100vw;
        align-content: center;
        padding-bottom: 90px;
        padding-top: 40px;
    }

    #items-org {
        flex: 1 0 calc(50% - 20px);
        max-width: calc(50% - 20px);
        flex-shrink: 0;
        flex-grow: 1;
        margin-bottom: 20px;
        margin-left: 5px;
        margin-right: 5px;;
    } 
}


</style>


